import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import ButtonCL from 'ui/atoms/Button'
import query from 'mediaQueries'
import { colors } from 'const/colors'
import { getFlexCSS } from 'ui/cssHelpers'
import { StyledButton } from './typing'

export const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column-reverse;
  background: ${colors.greyTwenty};
  @media ${query.greaterThanTiny} {
    flex-direction: row;
    justify-content: center;
  }
  @media ${query.greaterThanSmall} {
    padding: 16px 32px;
  }
`

const Button = styled(ButtonCL)<StyledButton>`
  margin: 0;
  @media ${query.greaterThanTiny} {
    flex: 1;
  }
`

export const PrimaryButton = styled(Button)<StyledButton>`
  @media ${query.greaterThanTiny} {
    ${({ $styles: { flex } }) => flex && getFlexCSS(flex)}
  }
`

const SecondaryButtonCSS = (
  display: StyledButton['$styles']['display'],
  flex: StyledButton['$styles']['flex'],
  $show: boolean
): FlattenSimpleInterpolation => {
  return css`
    display: ${$show ? 'block' : display};
    margin: ${$show ? '0' : '16px 0 0'};
    background-color: ${colors.white};
    @media ${query.greaterThanTiny} {
      display: block;
      ${flex && getFlexCSS(flex)}
      margin: ${$show ? '0' : '0 16px 0 0'};
    }
  `
}

export const SecondaryButton = styled(Button)<StyledButton>`
  ${({ $styles: { display = 'none', flex }, $show }) =>
    SecondaryButtonCSS(display, flex, $show)};
`
